import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { SAVING_STATE } from 'src/store/page-project/pageProject.constants';
import { useMemo } from 'react';
import { ToBeSavedButton } from './to-be-saved-button/ToBeSavedButton';
import { SavingButton } from './saving-button/SavingButton';
import { SavedButton } from './saved-button/SavedButton';
import { ProjectSaveButtonProps, WrapperProjectSaveButtonProps } from './ProjectSaveButton.types';

const PROJECT_SAVE_BUTTONS: Record<SAVING_STATE, React.ComponentType<ProjectSaveButtonProps>> = {
  [SAVING_STATE.toBeSaved]: ToBeSavedButton, // shows only if the use is not logged in
  [SAVING_STATE.saving]: SavingButton,
  [SAVING_STATE.uploading]: SavingButton,
  [SAVING_STATE.saved]: SavedButton,
};

export const ProjectSaveButton = observer(
  ({ isPressTooltipEnabled, focusOrder, focusGroup }: WrapperProjectSaveButtonProps) => {
    const {
      i18n,
      user: { isLogged },
      project: { activeProject, totalNumberOfProducts, isUploading },
      drawer: { openDrawer },
    } = useStore();

    const componentKey = isUploading
      ? SAVING_STATE.uploading
      : !isLogged
        ? SAVING_STATE.toBeSaved
        : activeProject?.savingState === SAVING_STATE.toBeSaved
          ? SAVING_STATE.saved
          : activeProject?.savingState;

    const Component = useMemo(() => {
      return (componentKey && PROJECT_SAVE_BUTTONS[componentKey]) ?? (() => <></>);
    }, [componentKey]);

    return (
      <Component
        i18n={i18n}
        openDrawer={openDrawer}
        totalNumberOfProducts={totalNumberOfProducts}
        lastSaveTimestamp={activeProject?.lastSaveTimestamp}
        isPressTooltipEnabled={isPressTooltipEnabled}
        text={!isUploading ? 'header:saving-project' : 'header:uploading'}
        focusOrder={focusOrder}
        focusGroup={focusGroup}
      />
    );
  },
);
